import React from "react";
import LinkedIn from "../../../assets/Images/linkedin.svg";
import Fb from "../../../assets/Images/facebook.svg";
import YouTube from "../../../assets/Images/youtube.svg";
import Twitter from "../../../assets/Images/twitter.svg";
import ClassplusLogo from "../../../assets/Images/classplus-logo.svg";
//import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="footerContainer">
      <div className="footer">
        <img src={ClassplusLogo} alt="" className="footer_logo" />

        <div className="footer_sm">
          <a
            href="https://www.facebook.com/classplusapp"
            rel="noopener noreferrer"
            className="footer_sm_link"
            target="_blank"
          >
            <img src={Fb} alt="Fb" />
          </a>
          <a
            href="https://www.youtube.com/channel/UCp0yDDnyu-C-0Bo_y1JbGtA"
            rel="noopener noreferrer"
            className="footer_sm_link"
            target="_blank"
          >
            <img src={YouTube} alt="Yt" />
          </a>
          <a
            href="https://www.linkedin.com/company/classplus/"
            rel="noopener noreferrer"
            className="footer_sm_link"
            target="_blank"
          >
            <img src={LinkedIn} alt="Ln" />
          </a>
          <a
            href="https://twitter.com/ClassplusApps"
            rel="noopener noreferrer"
            className="footer_sm_link"
            target="_blank"
          >
            <img src={Twitter} alt="tw" />
          </a>
        </div>
      </div>
      <div className="copyRightsContainer">2022 All Rights Reserved</div>
    </footer>
  );
};

export default Footer;
